export default __webpack_public_path__ + "static/media/vt03.1f5cbeb6.jpg";